import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HeroBanner } from "./hero-banner";


const Hero = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="relative w-full h-screen">
      <Slider {...settings}>
        <div className="relative">
          <HeroBanner
            location={"colombo"}
            videoLink={"/images/banner/colombo.png"}
          />
        </div>
        <div className="relative">
          <HeroBanner location={"galle"} videoLink={"/images/banner/galle.png"} />
        </div>
        <div className="relative">
          <HeroBanner location={"kandy"} videoLink={"/images/banner/kandy.png"} />
        </div>
        <div className="relative">
          <HeroBanner
            location={"nuwara eliya"}
            videoLink={"/images/banner/nuwara-eliya.jpeg"}
          />
        </div>
        <div className="relative">
          <HeroBanner location={"dubai"} videoLink={"/images/banner/dubai.png"} />
        </div>
      </Slider>









      {/* Optional Overlay for Better Text Contrast */}
      <div className="absolute inset-0 bg-black bg-opacity-30 pointer-events-none" />
    </div>
  );
};

export default Hero;
